module.exports = __webpack_public_path__ + "img/car-bump.7d538c5d.svg";